import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import { MobileModalBody } from "./MobileModalBody";
import { MobileModalHeader } from "./MobileModalHeader";
import "../css/EventAgenda.css";
import MobileModal from "./MobileModal";
import {
  useDeleteItem,
  useCreateItem,
  useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import EditPatientDetail from "./EditPatientDetail";
import RescheduleAppointment from "./RescheduleAppointment";
import { getDateInputFormat } from "../../_helper/utils.js/utils";
import { clinic_id } from "./BookEvent";
import moment from "moment";

export const Appointment_Icons = {
  O: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%281%29.png",
  N: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%282%29.png",
  NF: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%283%29.png",
  OF: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%284%29.png",
  Search: "https://cufront-assets.s3.amazonaws.com/icons+/Vector+%281%29.png",
  BookAppointment:
    "https://cufront-assets.s3.amazonaws.com/icons+/Mask+group.png",
  NoShow: "https://cufront-assets.s3.amazonaws.com/icons+/no-show.png",
  blocked: "https://cufront-assets.s3.amazonaws.com/icons+/blocked.png",
  continue_consultation:
    "https://cufront-assets.s3.amazonaws.com/icons+/continue_consultation.png",
  invoice: "https://cufront-assets.s3.amazonaws.com/icons+/invoice.png",
  book_appointment:
    "https://cufront-assets.s3.amazonaws.com/icons+/book_appointment.png",
  unblock: "https://cufront-assets.s3.amazonaws.com/icons+/unblocked.png",
};

const EventAgenda = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);

  const closeModal = () => setIsOpen(false);

  const event_border_colors = {
    booked: "blue",
    blocked: "red",
    Open: "green",
    complete: "black",
    no_show: "orange",
    video_consultation: "purple",
  };

  const borderColor =
    event_border_colors[props?.title === "no show" ? "no_show" : props?.title];

  const [editDetailModal, setEditDetailModal] = useState({
    data: null,
    flag: false,
  });

  const [isReschedule, setIsReschedule] = useState({
    data: null,
    flag: false,
  });
  const sm = !useMediaQuery({ query: "(min-width:1024px)" });

  const handleReschedule = (event) => {
    let startHours = `${event?.start?.getHours()}`;
    let startMin = `${event?.start?.getMinutes()}`;
    if (startHours?.length === 1) {
      startHours = `0${startHours}`;
    }
    if (startMin?.length === 1) {
      startMin = `0${startMin}`;
    }
    const existingSlotData = {
      date: getDateInputFormat(event?.start),
      startTime: `${startHours}:${startMin}`,
      duration: 5,
      slotId: event?.id,
      phone: event?.user_details?.phone,
      userName: event?.user_details?.full_name,
    };
    setIsReschedule({ data: existingSlotData, flag: true });
  };

  const handleEditPatient = (patientDetails) => {
    setEditDetailModal({
      data: patientDetails?.user_details,
      flag: true,
      slotId: patientDetails?.id,
    });
  };

  const deleteSlotMutation = useDeleteItem("qm_sc_slots");

  const handleDecline = (slotId) => {
    if (slotId) {
      deleteSlotMutation.mutate(slotId, {
        onSuccess: () => {
          alert("slot deleted successfully");
        },
        onError: () => {
          alert("please try again");
        },
      });
    }
  };

  const update_mutation = useUpdateItem("qm_sc_slots");

  const handleNoShow = (eventId) => {
    update_mutation.mutate(
      { id: eventId, data: { status: "no show" } },
      {
        onSuccess: () => alert("req sent successfully"),
        onError: () => alert("something went wrong"),
      }
    );
  };

  return (
    <>
      {props?.event?.title === "open" ? (
        <div
          id="open-block-event-container"
          style={{ border: `1.5px solid ${borderColor}` }}
        >
          <p>{props.event.title}</p>

          {sm ? (
            <div>
              <span>
                <img
                  style={{ width: "1.2rem" }}
                  src={Appointment_Icons["blocked"]}
                />
              </span>
            </div>
          ) : (
            <>
              <div
                style={{
                  marginLeft: "auto",
                  width: "fit-content",
                }}
                className="icons"
              >
                <span>
                  <img
                    style={{ width: "1.2rem" }}
                    src={Appointment_Icons["blocked"]}
                  />
                </span>
              </div>
            </>
          )}
        </div>
      ) : props.event.title == "no_show" ? (
        <>
          <div
            id="open-block-event-container"
            style={{ border: `1.5px solid ${borderColor}` }}
          >
            <p>{props?.event?.user_details?.full_name}</p>
            <p>{props.event.title == "no show" && "No Show"}</p>
          </div>
        </>
      ) : props.event.title == "blocked" ? (
        <div
          id="open-block-event-container"
          style={{ border: `1.5px solid ${borderColor}` }}
        >
          <p>{props.event.title == "blocked" && "Blocked"}</p>

          {sm ? (
            <div>
              <span>
                <img
                  style={{ width: "1.2rem" }}
                  src={Appointment_Icons["unblock"]}
                />
              </span>
            </div>
          ) : (
            <>
              <div
                style={{
                  marginLeft: "auto",
                  width: "fit-content",
                }}
                className="icons"
              >
                <span>
                  <img
                    style={{ width: "1.2rem" }}
                    src={Appointment_Icons["unblock"]}
                  />
                </span>
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          {sm && (
            <MobileModal
              modalClassName={"modal-container"}
              isOpen={isOpen}
              closeModal={closeModal}
              event={props}
            >
              <MobileModalHeader>
                <span>{props?.event?.text}</span>
                <h4>{props?.event?.user_details?.full_name}</h4>
                <span>
                  <span>{props?.event?.user_details?.age} yrs </span>
                  {props?.event?.user_details?.gender?.length > 0
                    ? props?.event?.user_details?.gender[0]
                    : ""}
                </span>
              </MobileModalHeader>
              <MobileModalBody>
                <div className="icons-mobile">
                  <div>
                    <Icon
                      style={{
                        color: "rgba(87, 208, 139, 1)",
                      }}
                      name="hourglass start"
                    />

                    <p>Start Consultation</p>
                  </div>

                  <div onClick={() => handleReschedule(props?.event)}>
                    <Icon
                      style={{
                        color: "rgba(53, 146, 255, 1)",
                      }}
                      name="time"
                    />
                    <p>Reschedule</p>
                  </div>

                  <div>
                    <Icon
                      style={{
                        color: "rgba(255, 101, 59, 1)",
                      }}
                      name="file"
                    />

                    <p>Invoice</p>
                  </div>

                  <div onClick={() => handleDecline(props?.event?.id)}>
                    <Icon
                      style={{
                        color: "rgba(245, 60, 89, 1)",
                      }}
                      name="close"
                    />
                    <p>Decline</p>
                  </div>

                  <div>
                    <a href={`tel:${props?.event?.user_details?.phone}`}>
                      <Icon
                        style={{
                          color: "rgba(0, 66, 195, 1)",
                          fontSize: "2em",
                        }}
                        name="call"
                      />
                    </a>

                    <p>Call Patient</p>
                  </div>

                  <div onClick={() => handleEditPatient(props?.event)}>
                    <Icon
                      style={{
                        color: "rgba(0, 66, 195, 1)",
                      }}
                      name="edit"
                    />
                    <p>Edit</p>
                  </div>
                  <div>
                    <span onClick={() => handleNoShow(props?.event?.id)}>
                      <img
                        style={{
                          width: "2rem",
                          margin: "auto",
                        }}
                        src={Appointment_Icons["NoShow"]}
                      />
                      <p>No Show</p>
                    </span>
                  </div>
                </div>
              </MobileModalBody>
            </MobileModal>
          )}

          <div onClick={openModal} className="custom-agenda-event-container">
            <div class="time">
              {" "}
              <p>{props?.event.text}</p>
            </div>
            <div class="name">
              {" "}
              <h4> {props?.event.user_details.full_name}</h4>
              <p>
                <span>{props?.event?.user_details?.age} yrs</span>{" "}
                {props?.event?.user_details?.gender?.length > 0
                  ? props?.event?.user_details?.gender[0]
                  : ""}
              </p>
            </div>
          </div>
        </>
      )}

      {editDetailModal.flag && (
        <EditPatientDetail
          isOpen={editDetailModal}
          setIsOpen={setEditDetailModal}
        />
      )}
      {isReschedule?.flag && (
        <RescheduleAppointment
          isReschedule={isReschedule}
          setIsReschedule={setIsReschedule}
        />
      )}
    </>
  );
};

export default EventAgenda;
